export const trustedDomains = [
  process.env.PUBLIC_URL,
  'https://generate.tax',
  (process.env.API_URL || '').replace('/api', ''),
  'https://authorize.xero.com/',
  'https://login.xero.com/',
  'https://api.generate.tax/',
  'https://checkout.stripe.com/',
  'https://billing.stripe.com',
  'https://invoice.stripe.com/',
  'https://pay.stripe.com/',
  'https://accounts.google.com/',
  'https://login.microsoftonline.com/',
  'https://appcenter.intuit.com/',
  'https://www.tax.service.gov.uk/',
  'https://test-api.service.hmrc.gov.uk/',
  'https://help.generate.tax',
  'https://accounts.zoho',
  'https://api.service.hmrc.gov.uk/',
];
